import * as Diagram from "../../../../components/diagram";

export const ReferralList = {
  label: "轉介清單",
  key: "ReferralList",
  path: "BoneMuscleCare/ReferralList",
  api: "TCS_V_CaseTransferInfo04V",
  render: (options) => <Diagram.BoneMuscleCare.ReferralList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "Transed", label: "轉介完成", type: "string" },
    { key: "RegionName", label: "鄉鎮", type: "string" },
  ],
  dateRangeColumns: [{ label: "回覆日期", key: "回覆日期" }],
  columns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "鄉鎮",
    },
    {
      key: "個案姓名",
      field: "個案姓名",
      header: "個案姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "轉介日期",
      field: "轉介日期",
      header: "轉介日期",
    },
    {
      key: "轉介醫院",
      field: "轉介醫院",
      header: "轉介醫院",
    },
    {
      key: "Transed",
      field: "Transed",
      header: "轉介完成",
    },
    {
      key: "回覆日期",
      field: "回覆日期",
      header: "回覆日期",
    },
    {
      key: "藥物名稱",
      field: "藥物名稱",
      header: "是否用藥",
    },
    {
      key: "其他注意事項",
      field: "其他注意事項",
      header: "其他注意事項",
    },
  ],
};
